var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobilePhoneIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "173px",
    height: "173px",
    viewBox: "0 0 173 173",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "notapproved") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Thank-You",
    transform: "translate(-633.000000, -231.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page"
  }), /*#__PURE__*/React.createElement("g", {
    id: "notapproved",
    transform: "translate(633.580698, 231.580698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.6471917,143.167901 C109.246426,117.207531 150.419302,111.441195 150.419302,79.4174561 C150.419302,47.3937175 135.341654,26.0497056 104.509172,8.99168116 C73.6766893,-8.0663433 66.0453507,39.3563163 34.1010526,79.4174561 C2.15675451,119.478596 38.0479568,169.12827 73.6471917,143.167901 Z",
    id: "Oval",
    fill: "#EEF6FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconfinder_659143_alert_communication_message_mobile_phone_icon",
    transform: "translate(85.919302, 85.919302) rotate(-4.000000) translate(-85.919302, -85.919302) translate(5.419302, 5.419302)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 161,
    height: 161
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 20,
    y: 20,
    width: 121,
    height: 121
  }), /*#__PURE__*/React.createElement("g", {
    id: "_392016616",
    transform: "translate(46.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.66661445,0 L62.3333856,0 C65.4500537,0 68,2.56461325 68,5.69930248 L68,115.300698 C68,118.435473 65.4500537,121 62.3333856,121 L5.66661445,121 C2.54994635,121 0,118.435481 0,115.300698 L0,5.69930248 C0,2.56461325 2.54994635,0 5.66661445,0 Z",
    id: "_392011360",
    fill: "#000A2F"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_392017576",
    fill: "#EEF6FF",
    points: "3.92317453 12.6041092 64.0769038 12.6041092 64.0769038 103.353774 3.92317453 103.353774"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0000392,108.686888 C35.8214675,108.686888 37.2982102,110.172125 37.2982102,112.00403 C37.2982102,113.835935 35.8214675,115.321171 34.0000392,115.321171 C32.1786109,115.321171 30.7018681,113.835935 30.7018681,112.00403 C30.7018681,110.172125 32.1786109,108.686888 34.0000392,108.686888 Z",
    id: "_392019088",
    fill: "#2F3F7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8455792,40.7604209 L20.7003473,40.7604209 C18.3128473,40.7604209 15.5628898,42.8912795 15.5628898,44.9521696 L15.5628898,61.4940388 C15.5628898,63.3875384 17.8883171,64.7606616 20.1254875,64.9687948 L18.6720622,70.5185732 L27.9868828,65.010286 L47.8456027,65.010286 C50.2282934,65.010286 52.4369692,63.5484062 52.4369692,61.494031 L52.4369692,44.9521617 C52.4369692,42.8912795 50.2282934,40.7604209 47.8456027,40.7604209 L47.8455792,40.7604209 Z",
    id: "_392018824",
    fill: "#008AEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8411639,54.7242851 C23.4850576,54.7242851 22.3912153,53.6238755 22.3912153,52.2584802 C22.3912153,50.8997809 23.4850576,49.7927698 24.8411639,49.7927698 C26.1920929,49.7927698 27.2932351,50.8997887 27.2932351,52.2584802 C27.2932351,53.6238755 26.1920851,54.7242851 24.8411639,54.7242851 Z",
    id: "_392012272",
    fill: "#EEF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9953397,54.7242851 C32.646079,54.7242851 31.5450229,53.6238755 31.5450229,52.2584802 C31.5450229,50.8997809 32.646079,49.7927698 33.9953397,49.7927698 C35.3534824,49.7927698 36.4473169,50.8997887 36.4473169,52.2584802 C36.4473169,53.6238755 35.3534746,54.7242851 33.9953397,54.7242851 Z",
    id: "_392018200",
    fill: "#EEF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1570346,54.7242851 C41.8080559,54.7242851 40.7066239,53.6238755 40.7066239,52.2584802 C40.7066239,50.8997809 41.808048,49.7927698 43.1570346,49.7927698 C44.5078696,49.7927698 45.6085497,50.8997887 45.6085497,52.2584802 C45.6085497,53.6238755 44.5078618,54.7242851 43.1570346,54.7242851 Z",
    id: "_392018368",
    fill: "#EEF6FF"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePhoneIcon);
export default __webpack_public_path__ + "static/media/mobile-phone-icon.3f0b5dc968e8109b91f8f771360c386a.svg";
export { ForwardRef as ReactComponent };